import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Grupo, ISgrupo } from "../../types/grupo/Grupo";
import { Panel } from "primereact/panel";
import { GrupoForm } from "./GrupoForm";
import { useCreateGrupo1Mutation, useCreateGrupoMutation } from "./grupoApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";


export const GrupoCreate = () => {

    const [grupo, setGrupo] = useState<Grupo>(ISgrupo);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createGrupo, status] = useCreateGrupo1Mutation();
    const navigate = useNavigate();


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setGrupo((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await createGrupo(grupo);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(configUrls.GRUPO_ACOMPANHAMENTO_LIST);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Grupos de Acompanhamento
                </Typography>



                <GrupoForm
                    data={grupo}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />

            </Paper>










        </>







    );










};

/*
 <GrupoTurmaForm
                    grupoTurma={grupoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/